import { useState, useEffect } from 'react';
import { getReports } from '../api/reportsService';
import { ReportData } from '../types/interfaces';

/**
 * Hook que obtiene la lista de reports y el 'reportSummary'
 * (en realidad es el mismo ReportData seleccionado).
 * Si no se selecciona ninguno, reportSummary = null.
 */
const useReports = (selectedReportId: string | null) => {
  const [reports, setReports] = useState<ReportData[]>([]);
  const [reportSummary, setReportSummary] = useState<ReportData | null>(null);
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string>('');

  useEffect(() => {
    const fetchReports = async () => {
      try {
        const data = await getReports();
        setReports(data);

        if (selectedReportId) {
          // Aquí comparamos string con string
          const selectedReport = data.find((report) => report.id === selectedReportId);
          setReportSummary(selectedReport || null);
        } else {
          setReportSummary(null);
        }
      } catch (err: any) {
        setError('Error al obtener los informes');
      } finally {
        setLoading(false);
      }
    };

    fetchReports();
  }, [selectedReportId]);

  return { reports, reportSummary, loading, error };
};

export default useReports;
